import { getListStatusTime, resolveListCardMovement } from "./listCardMovement";

export const LiveStatusIndicator = ({
  data = {},
  cardType = "Vehicles",
  mapData,
  telemetry,
  plateNumber,
}) => {
  const liveData = mapData?.[data.device_name_list] || {};
  const { movementStatus } = resolveListCardMovement({
    telemetry,
    plateNumber,
    fallback: {
      observedAt: getListStatusTime(cardType, liveData, data.lastUpdated, data.source_time),
      deviceDataAt: data.lastUpdated,
      rawSpeed: liveData.rawSpeed ?? data.rawSpeed,
      ignition: liveData.ignition ?? data.ignition,
    },
  });

  return ["moving", "paused", "parked"].includes(movementStatus)
    ? <span className="live-icon" aria-hidden="true" data-testid="live-status-indicator" />
    : null;
};
